import React, { Component } from 'react';
import firebase from 'firebase/app';
import './style.css';

// importing components
import MenuBar from './MenuBar.js';
import Brand from './Brand.js';
import Features from './Features.js';
import Push from './button.js';
import About from './About.js';
import Footer from './Footer.js';
import { Route, Switch } from 'react-router-dom';
import AboutPage from './AboutPage.js';
import FavoritesPage from './FavoritesPage.js';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            restaurants: []
        }
    }

    // Updates the current user
    updateUser(user) {
        this.setState({
            user: user
        });
    }

    addRestaurant(restaurant) {
        let newRestaurant = {
            id: restaurant.id,
            phone: restaurant.phone,
            image: restaurant.image,
            name: restaurant.name,
            rating: restaurant.rating,
            review_count: restaurant.review_count,
            address: restaurant.address,
            city: restaurant.city,
            state: restaurant.state,
            zipcode: restaurant.zipcode,
            coordinates: restaurant.coordinates,
            url: restaurant.url,
            is_closed: restaurant.is_closed
        };

        let firebaseRef = firebase.database().ref(`restaurants/${this.state.user.uid}/favorites`);
        
        firebaseRef.orderByChild('name').equalTo(`${restaurant.name}`).once('value', snapshot => {
            if (snapshot.exists()) {
                alert('Already added restaurant!');
            } else {
                firebaseRef
                    .push(newRestaurant)
                    .catch(err => alert);
            }
        });
    }

    render() {
        return (
            <div>
                <header>
                    <MenuBar updateUser={user => { this.updateUser(user) }}/>
                </header>
                <Switch>
                    <Route exact path ="/" render={() => { return (
                        <main>
                            <Brand />
                            <Features />
                            <Push addRestaurant={restaurant => this.addRestaurant(restaurant)} />
                            <About />
                            <Footer />
                        </main>
                    )}}/>
                    <Route path="/about" render={() => {
                        return(
                            <main>
                            <AboutPage />
                            <Footer />
                            </main>
                        );
                    }}/>
                    <Route path="/favorites/:uid" render={(props) => {
                        return(
                            <main>
                            <FavoritesPage {...props} user={this.state.user} restaurants={this.state.restaurants} />
                            <Footer />
                            </main>
                        );
                    }}/>
                </Switch>
            </div>        
        );
    }
}

export default App;